
import { defineComponent } from 'vue';
import topToolbar from './topToolbar.vue';

export default defineComponent({
  components: {
    topToolbar,
  },
  props: {
    collapsed: Boolean,
  },
  setup(props, context) {
    const userSelectPath = (e) => {
      context.emit('userSelectPath', e);
    };
    return {
      props,
      userSelectPath,
    };
  },
});
